// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".block[data-v-71d9831c]{margin-top:10px}.url-input .inner[data-v-71d9831c]{background:#d9e2fa;padding:1px}.block .label-icon[data-v-71d9831c],.block .label-minus[data-v-71d9831c],.block .label-plus[data-v-71d9831c]{line-height:52px;width:52px;height:52px}.block .label-icon+input[data-v-71d9831c],.block .label-minus+input[data-v-71d9831c],.block .label-plus[data-v-71d9831c]{margin-left:-52px}.swal2-actions[data-v-71d9831c]{margin:0}", ""]);
// Exports
module.exports = exports;
